import React, { useContext, useEffect, useState } from "react";
import { Title } from "react_reusable_components";
import { useIntl } from "react-intl";

import CallLobbyComponent from "../../components/CallLobbyComponent/CallLobbyComponent";
import { RemoteAuditContext } from "../../globalContext/remoteAudit/remoteAuditProvider";
import RemoteAuditQuestionnaireContainer from "../RemoteAuditQuestionnaireContainer/RemoteAuditQuestionnaireContainer";
import { AuditContext } from "../../globalContext/ManageAudit/AuditProvider";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { AUDIT_LINK_TOKEN_EXPIRE } from "../../constants/errorConstants";
import variables from "../../themes/base/styles/variables";

const RemoteAuditContainerStyle = {
  errorBox: {
    height: variables.fullHeight,
    width: variables.fullWidth,
    display: variables.dFlex,
    justifyContent: variables.justifyCenter,
    alignItems: variables.justifyCenter,
    textAlign: variables.justifyCenter,
    padding: variables.paddingMedium,
  },
  msgColor: { color: variables.successGreen },
};

export default function RemoteAuditContainer() {
  const [remoteAuditState] = useContext(RemoteAuditContext);
  const [auditState] = useContext(AuditContext);
  const [isTokenExpired, setIsTokenExpired] = useState(false);

  useEffect(() => {
    if (auditState?.auditErrorCode === AUDIT_LINK_TOKEN_EXPIRE) {
      setIsTokenExpired(true);
    }
  }, [auditState?.auditErrorCode]);

  const intl = useIntl();

  if (isTokenExpired) {
    return (
      <div style={RemoteAuditContainerStyle.errorBox}>
        <Title style={RemoteAuditContainerStyle.msgColor}>
          {getLocalizedMessage(intl, "dnsd.selfAudit.linkExpired")}
        </Title>
      </div>
    );
  }

  return remoteAuditState?.room?.token ? (
    <RemoteAuditQuestionnaireContainer />
  ) : (
    <CallLobbyComponent />
  );
}
